export const DEFAULT_LANGUAGE = 'fi';

// In the order of the language flags: Finnish, Swedish, English
export const SUPPORTED_LANGUAGES = ['fi', 'sv', 'en'];

// Language names are shown in their own language so users can always find theirs.
export const LANGUAGE_NAMES: { [language: string]: string } = {
  en: 'English',
  fi: 'Suomi',
  sv: 'Svenska',
};

const STORAGE_KEY = 'eworkbook.language';

export const isSupportedLanguage = (
  language: string | null | undefined
): language is string =>
  typeof language === 'string' && SUPPORTED_LANGUAGES.includes(language);

// Remembers the last used language so the GUI starts in it before the user is loaded.
export const getStoredLanguage = (): string => {
  try {
    const language = window.localStorage.getItem(STORAGE_KEY);
    return isSupportedLanguage(language) ? language : DEFAULT_LANGUAGE;
  } catch (e) {
    return DEFAULT_LANGUAGE;
  }
};

export const storeLanguage = (language: string): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, language);
  } catch (e) {
    // Storage can be unavailable (e.g. private mode); the server copy still applies.
  }
};
